import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { useAuth } from "@/src/auth/hooks/use-auth";

export function AuthGuard({ children }: { children: ReactNode }) {
	const { user, isLoading } = useAuth();
	if (isLoading) return null;
	if (!user) return <Navigate to={AUTH_ROUTES.LOGIN} replace />;
	return <>{children}</>;
}
